import React from 'react'
import { getConfig } from '../../../config'
import { useCommonServices } from '../../hooks'
import Script from 'next/script'
import { isEligibleForTracking } from '../index'

const gtmConfig = getConfig().acquisitionTracking.googleTagManager
const tagManagerUrl = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
  gtmConfig.id
)}&l=${encodeURIComponent(gtmConfig.layer)}`

const gtmCode = `(function(w,d,s,l,m){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(m)[0],
  j=d.createElement(s);j.async=true;j.src=
  '${tagManagerUrl}';f.parentNode.insertBefore(j,f);
  })(window,document,'script', '${gtmConfig.layer}', 'meta');`

export const GtmScript: React.FC = () => {
  const { userService } = useCommonServices()

  if (!isEligibleForTracking(userService.currentUser)) {
    return null
  }

  return <Script id="gtm-setup" strategy="afterInteractive" dangerouslySetInnerHTML={{ __html: gtmCode }} />
}

export const GtmNoScript: React.FC = () => {
  const { userService } = useCommonServices()

  if (!isEligibleForTracking(userService.currentUser)) {
    return null
  }

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(gtmConfig.id)}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  )
}
